export default "__VITE_ASSET__a444730d__"